import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded';
export default function Notification() {
    return (
        <div className="home-noti">
            <div className="home-title">
                <span >Thông báo mới</span>
            </div>
        </div>
    )
}